import { Component, ElementRef, OnInit, Renderer2, ViewChild } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Entry } from 'contentful';
import { CountryISO, PhoneNumberFormat, SearchCountryField } from 'ngx-intl-tel-input';
import { NdcCreditVoucherRedemptionPage } from 'src/app/model/page/group/forms/ndc-credit-voucher-redemption/ndc-credit-voucher-redemption-page';
import { NDCCreditVoucherRedemptionLabels } from 'src/app/model/page/group/forms/ndc-credit-voucher-redemption/ndc-credit-voucher-redemption-page-labels';
import { NdcCreditVoucherRedemption } from 'src/app/model/page/group/forms/ndc-credit-voucher-redemption-request';
import { ApiService } from 'src/app/service/api.service';
import { entraAuthService } from 'src/app/service/auth.service';
import { CommonService } from 'src/app/service/common.service';
import { ContentfulService } from 'src/app/service/contentful.service';
import { PageLoaderService } from 'src/app/service/page-loader.service';
import { ModelValidator } from 'src/app/validator/model-validator';
import htmlTitle from 'src/assets/json/redirects/html-title.json';

@Component({
  selector: 'app-ndc-credit-voucher-redemption-page',
  templateUrl: './ndc-credit-voucher-redemption-page.component.html',
  styleUrls: ['./ndc-credit-voucher-redemption-page.component.scss']
})
export class NdcCreditVoucherRedemptionPageComponent implements OnInit {
  ndcCreditVoucherRedemptionPage: NdcCreditVoucherRedemptionPage = {} as NdcCreditVoucherRedemptionPage;
  ndcCreditVoucherRedeemRequest: NdcCreditVoucherRedemption = {} as NdcCreditVoucherRedemption;
  ndcCreditVoucherRedemptionLabels: NDCCreditVoucherRedemptionLabels = {} as NDCCreditVoucherRedemptionLabels;
  @ViewChild('countryCode')
  countryCode!: ElementRef;
  showRedemptionForm = false;
  submitted = false;
  ticketsAdded = false;
  requiredFieldError = false;
  showCustomerSupportMessage = false;
  showDuplicateVoucherError = false;
  ticketNumbers: any = [];
  EMDList: any = [];
  countryList: any[] = [];
  ticketAndEMDList: any = [];
  showAdcCollectedCreditCardCheckbox = false;
  checked: any;
  separateDialCode = false;
  issueRedeemSuccess = false;
  redeemFailedMsg = '';
  selectedCountryCode = '';

  showSFPD = false;
  SearchCountryField = SearchCountryField;
  CountryISO = CountryISO;
  isConfirmAdditionalCollectionChecked = true;
  isconfirmEMDChecked = true;
  PhoneNumberFormat = PhoneNumberFormat;
  preferredCountries: CountryISO[] = [CountryISO.UnitedStates, CountryISO.UnitedKingdom, CountryISO.Spain, CountryISO.Germany, CountryISO.France, CountryISO.Russia];
  selectedCountry = {
    name: 'United Kingdom',
    value: 'GB'
  };

  redeemCreditVoucherForm: FormGroup = new FormGroup({
    travelWithiHhours: new FormControl(false),
    requireInstantTicketing: new FormControl(false),
    adcRequired: new FormControl(false),
    adcCollectedCreditCard: new FormControl(false),
    BAdirectCustomer: new FormControl(false),
    contactName: new FormControl(''),
    contactEmail: new FormControl(''),
    phone: new FormControl(''),
    agencyName: new FormControl(''),
    IATAnumber: new FormControl(''),
    creditVoucherRef: new FormControl(''),
    voucherType: new FormControl(''),
    locationCountry: new FormControl(),
    creditVoucherRefPrefix: new FormControl(),
    PNRnumber: new FormControl(''),
    applyNameChange: new FormControl(false),
    containUSCanadaFlight: new FormControl(false),
    passengerSFPD: new FormControl(false),
    TKTorEMDnumber: new FormControl(false),
    confirmAdditionalCollection: new FormControl(false),
    confirmEMD: new FormControl(false),
    nwBaci: new FormControl()
  });
  model1: any = {
    onColor: 'primary',
    offColor: 'secondary',
    onText: 'Yes',
    offText: 'No',
    disabled: false,
    size: 'sm',
    value: null
  };
  model2: any = {
    onColor: 'primary',
    offColor: 'secondary',
    onText: 'ETKT',
    offText: 'EMD',
    disabled: false,
    size: '',
    value: null
  };
  @ViewChild('checkbox2') checkbox2!: ElementRef;

  constructor(
    private renderer: Renderer2,
    private contentfulService: ContentfulService,
    private formBuilder: FormBuilder,
    private elementRef: ElementRef,
    private apiService: ApiService,
    private pageLoaderService: PageLoaderService,
    private auth: entraAuthService,
    private commonService: CommonService
  ) {}

  onChange(): void {
    // console.log('changed');
  }

  ngOnInit(): void {
    htmlTitle.filter((title) => {
      if (title.page === 'reedem-credit-vouchers') {
        this.ndcCreditVoucherRedemptionPage.htmlTitle = title.htmlTitle;
      }
    });
    const query = { 'fields.title': 'NDC Credit Voucher Redemption' };
    this.selectedCountry = {
      name: 'United Kingdom',
      value: 'GB'
    };
    this.ndcCreditVoucherRedemptionPage.TermsAndConditionsSections = [];
    this.ndcCreditVoucherRedemptionPage.NDCCallSupportSections = [];
    this.contentfulService.getPageContentResponse(query).then((ndcCreditVoucherRedemptionEntries) => {
      this.mapBanner(ndcCreditVoucherRedemptionEntries.includes.Entry);
      this.mapSections(ndcCreditVoucherRedemptionEntries.includes.Entry);
      this.mapHtmlTitle(ndcCreditVoucherRedemptionEntries.items);
    });
    this.mapNDCLabels();
    //this.countryCode.nativeElement.value={ name: '(please select a country)', code: '0' };
    //this.selectedCountry={ name: '(please select a country)', code: '0' };;

    this.redeemCreditVoucherForm = this.formBuilder.group({
      requireInstantTicketing: [false],
      travelWithiHhours: [false],
      adcRequired: [false],
      adcCollectedCreditCard: [false],
      BAdirectCustomer: [false],
      applyNameChange: [false],
      containUSCanadaFlightL: [false],
      passengerSFPD: [false],
      contactName: ['', [Validators.required, Validators.minLength(2), Validators.maxLength(30)]],
      contactEmail: ['', [Validators.required, Validators.email, Validators.minLength(2), Validators.maxLength(30)]],
      agencyName: ['', [Validators.required, Validators.minLength(1), Validators.maxLength(100)]],
      IATAnumber: ['', [Validators.required, Validators.minLength(7), Validators.maxLength(10)]],
      phone: ['', [Validators.required]],
      creditVoucherRef: ['', [Validators.minLength(10), Validators.maxLength(10)]],
      voucherType: [''],
      mySwitch: [true, [Validators.required]],
      locationCountry: [[Validators.required]],
      creditVoucherRefPrefix: ['125-', [Validators.required]],
      PNRnumber: ['', [Validators.required, Validators.minLength(6), Validators.maxLength(6), Validators.pattern(/^[a-zA-Z0-9]*$/)]],
      TKTorEMDnumber: [false],
      confirmAdditionalCollection: [false, [Validators.required]],
      confirmEMD: [false, [Validators.required]],
      nwBaci: ['']
    });
  }
  ngAfterViewChecked(): void {
    localStorage.removeItem('redirect_url');
  }

  private mapHtmlTitle(items: Entry<any>[]) {
    items.forEach((entry: any) => {
      this.ndcCreditVoucherRedemptionPage.htmlTitle = entry.fields.htmlTitle;
    });
  }

  private mapBanner(loginPageEntries: Entry<any>[]) {
    loginPageEntries
      .filter((entry) => ModelValidator.isBanner(entry))
      .forEach((entry) => {
        this.mapEntryToBanner(entry);
      });
  }

  private mapSections(creditVoucherRedemptionPageEntries: Entry<any>[]) {
    creditVoucherRedemptionPageEntries
      .filter((entry) => ModelValidator.isSection)
      .forEach((entry) => {
        switch (entry.fields['title']) {
          case 'NDC Credit Voucher Redemption#Terms & Conditions':
            this.mapTermsAndConditionsSection(entry);
            break;
          case 'NDC Credit Voucher Redemption#Call NDC trade support':
            this.mapNDCTrandeSupportSection(entry);
            break;
          default:
            break;
        }
      });
  }

  private mapTermsAndConditionsSection(entry: Entry<any>) {
    let givenTitle: any = entry.fields['title'] as string;
    let pageTitle = givenTitle.split('#').pop();

    this.ndcCreditVoucherRedemptionPage.TermsAndConditionsSections.push({
      title: pageTitle,
      body: entry.fields['body'] as string,
      group: entry.fields['group'] as string,
      order: entry.fields['order'] as number
    });
  }
  private mapNDCTrandeSupportSection(entry: Entry<any>) {
    let givenTitle: any = entry.fields['title'] as string;
    let pageTitle = givenTitle.split('#').pop();

    this.ndcCreditVoucherRedemptionPage.NDCCallSupportSections.push({
      title: pageTitle,
      body: entry.fields['body'] as string,
      group: entry.fields['group'] as string,
      order: entry.fields['order'] as number
    });
  }

  private mapEntryToBanner(entry: Entry<any>) {
    let imageDetails: any = entry.fields['image'];
    let videoDetails: any = entry.fields['video'];

    this.ndcCreditVoucherRedemptionPage.banner = {
      title: entry.fields['title'] as string,
      subTitle: entry.fields['subTitle'] as string,
      image: imageDetails.fields.file.url,
      video: videoDetails?.fields?.file?.url
    };
  }
  private mapNDCLabels() {
    // this.sideMenu.links = [];

    const query = { 'fields.title': 'NDC Credit Voucher Redemption' };
    this.contentfulService.getPageContentWithItems(query).then((labelItems) => {
      this.mapLables(labelItems[0]?.fields.constants);
    });
  }
  get countries() {
    this.countryList = this.commonService.getCountries();
    return this.commonService.getCountries();
  }
  mapLables(labels: any) {
    this.ndcCreditVoucherRedemptionLabels = {
      mainHeading: labels.mainHeading,
      agencyDeatailsHeading: labels.agencyDetails.heading,
      agencyName: labels.agencyDetails.agencyName,
      iata: labels.agencyDetails.iata,

      yourDetailsHeading: labels.yourDetails.heading,
      contactEmail: labels.yourDetails.contactEmail,
      contactName: labels.yourDetails.contactName,
      contactPhone: labels.yourDetails.contactPhone,

      CreditVoucherDetailsHeading: labels.creditVoucherDetails.heading,
      creditVoucherRef: labels.creditVoucherDetails.creditVoucherRef,
      newPNR: labels.creditVoucherDetails.newPNR,
      ticketNumbers: labels.creditVoucherDetails.ticketNumbers,
      add: labels.buttons.add,

      instructionText: labels.toggleSection.instructionText,
      outboundTravelWithin72Hours: labels.toggleSection.outboundTravelWithin72Hours,
      bookingRequireInstantTicketing: labels.toggleSection.bookingRequireInstantTicketing,
      isADCrequired: labels.toggleSection.isADCrequired,
      ADCcollectedViaCC: labels.toggleSection.ADCcollectedViaCC,
      voucherOriginateFrom: labels.toggleSection.voucherOriginateFrom,
      YourLocationCountry: labels.toggleSection.YourLocationCountry,
      next: labels.buttons.next,
      invalidContactName: labels.errorMessages.invalidContactName,
      invalidEmail: labels.errorMessages.invalidEmail,
      invalidPhoneNumber: labels.errorMessages.invalidPhoneNumber,
      invalidAgencyName: labels.errorMessages.invalidAgencyName,
      invalidIATAnumber: labels.errorMessages.invalidIATAnumber,
      invalidTicketNtmber: labels.errorMessages.invalidTicketNtmber,
      voucherAlreadyEntered: labels.errorMessages.voucherAlreadyEntered,
      invalidPNR: labels.errorMessages.invalidPNR,
      applyingNameChange: labels.toggleSection.applyingNameChange,
      bookingContainCanadaUSflight: labels.toggleSection.bookingContainCanadaUSflight,
      enteredSFPD: labels.toggleSection.enteredSFPD,
      invalidSFPD: labels.errorMessages.invalidSFPD,
      additionalCollectionRequired: labels.confirmation.additionalCollectionRequired,
      confirmResidualValue: labels.confirmation.confirmResidualValue,
      checkAllRequired: labels.errorMessages.checkAllRequired,
      back: labels.buttons.back,
      Submit: labels.buttons.Submit,
      redeemSuccess: labels.successMsg.redeemSuccess
    };
  }

  showNxt() {
    if (this.countryCode?.nativeElement?.value === '(please select a country)' || this.countryCode?.nativeElement?.value === '') {
      this.requiredFieldError = true;
    } else {
      this.requiredFieldError = false;
      //this.selectedCountry=this.countryCode?.nativeElement?.value;
      this.selectedCountryCode = this.countryCode?.nativeElement?.value;
      if (this.redeemCreditVoucherForm.value.travelWithiHhours || this.redeemCreditVoucherForm.value.requireInstantTicketing) {
        this.showCustomerSupportMessage = true;
        this.showRedemptionForm = false;
      }
      if (
        ((this.redeemCreditVoucherForm.value.travelWithiHhours || this.redeemCreditVoucherForm.value.requireInstantTicketing) && this.redeemCreditVoucherForm.value.adcRequired) ||
        this.redeemCreditVoucherForm.value.adcCollectedCreditCard
      ) {
        this.showCustomerSupportMessage = true;
        this.showRedemptionForm = false;
      }
      if (
        !this.redeemCreditVoucherForm.value.travelWithiHhours &&
        !this.redeemCreditVoucherForm.value.requireInstantTicketing &&
        this.redeemCreditVoucherForm.value.adcRequired &&
        !this.redeemCreditVoucherForm.value.adcCollectedCreditCard
      ) {
        this.showCustomerSupportMessage = false;
        this.showRedemptionForm = true;
      }
      if (
        this.redeemCreditVoucherForm.value.travelWithiHhours &&
        this.redeemCreditVoucherForm.value.requireInstantTicketing &&
        this.redeemCreditVoucherForm.value.adcRequired &&
        this.redeemCreditVoucherForm.value.adcCollectedCreditCard &&
        this.redeemCreditVoucherForm.value.BAdirectCustomer
      ) {
        this.showCustomerSupportMessage = true;
        this.showRedemptionForm = false;
      }
      if (
        !this.redeemCreditVoucherForm.value.travelWithiHhours &&
        !this.redeemCreditVoucherForm.value.requireInstantTicketing &&
        !this.redeemCreditVoucherForm.value.adcRequired &&
        !this.redeemCreditVoucherForm.value.BAdirectCustomer
      ) {
        this.showCustomerSupportMessage = false;
        this.showRedemptionForm = true;
      }
      if (this.redeemCreditVoucherForm.value.BAdirectCustomer) {
        this.showCustomerSupportMessage = true;
        this.showRedemptionForm = false;
      }
    }
  }

  goBack() {
    this.showRedemptionForm = false;
    if (this.selectedCountry) {
      this.countryCode.nativeElement.value = this.selectedCountryCode;
    }
  }

  get f(): { [key: string]: AbstractControl } {
    return this.redeemCreditVoucherForm.controls;
  }

  async submitVoucherRedemption(redeemCreditVoucherForm: FormGroup) {
    this.submitted = true;

    this.issueRedeemSuccess = false;
    this.redeemFailedMsg = '';
    if (
      (this.showSFPD && !redeemCreditVoucherForm.value.passengerSFPD) ||
      !redeemCreditVoucherForm.value.confirmEMD ||
      !redeemCreditVoucherForm.value.confirmAdditionalCollection ||
      this.ticketAndEMDList.length === 0
    ) {
      return;
    }
    if (redeemCreditVoucherForm.valid) {
      this.pageLoaderService.addPageLoader(true);

      this.ndcCreditVoucherRedeemRequest.contactName = redeemCreditVoucherForm.value.contactName;
      this.ndcCreditVoucherRedeemRequest.country = this.selectedCountryCode;
      this.ndcCreditVoucherRedeemRequest.contactEmail = redeemCreditVoucherForm.value.contactEmail;
      this.ndcCreditVoucherRedeemRequest.contactPhone = redeemCreditVoucherForm.value.phone?.e164Number;
      this.ndcCreditVoucherRedeemRequest.agencyDetails = {
        agencyName: redeemCreditVoucherForm.value.agencyName,
        iataNumber: redeemCreditVoucherForm.value.IATAnumber,
        bacciCLIDCode: redeemCreditVoucherForm.value.nwBaci
      };

      this.ndcCreditVoucherRedeemRequest.voucherDetails = {
        etickets: this.ticketNumbers.map(function (tkt: any) {
          return tkt.number;
        }),
        emds: this.EMDList.map(function (tkt: any) {
          return tkt.number;
        })
      };

      this.ndcCreditVoucherRedeemRequest.pnr = redeemCreditVoucherForm.value.PNRnumber;
      this.ndcCreditVoucherRedeemRequest.nameChangeForCorpBusiness = redeemCreditVoucherForm.value.applyNameChange;
      this.ndcCreditVoucherRedeemRequest.doesBookingContainUSCanadaFlight = !redeemCreditVoucherForm.value.containUSCanadaFlightL;
      if (this.ndcCreditVoucherRedeemRequest.voucherDetails.emds?.length === 0) {
        delete this.ndcCreditVoucherRedeemRequest.voucherDetails.emds;
      }
      if (this.ndcCreditVoucherRedeemRequest.voucherDetails.etickets?.length === 0) {
        delete this.ndcCreditVoucherRedeemRequest.voucherDetails.etickets;
      }
      if (this.ndcCreditVoucherRedeemRequest.agencyDetails.bacciCLIDCode === '') {
        delete this.ndcCreditVoucherRedeemRequest.agencyDetails.bacciCLIDCode;
      }

      const apiResponse = await this.apiService.sendPostRequest(this.ndcCreditVoucherRedeemRequest, '/voucher/redeem');
      if (apiResponse.error) {
        if (apiResponse.error) {
          this.redeemFailedMsg = apiResponse.error.message;
        }
        if (apiResponse.error.status == 401) {
          localStorage.setItem('redirect_url', '/forms/ndc-credit-voucher-redemption');
          this.auth.initLogin();
        }
      } else {
        this.issueRedeemSuccess = true;
      }
    }
  }

  addTicket() {
    let ticket: any;
    this.ticketsAdded = true;

    if (this.redeemCreditVoucherForm.get('creditVoucherRef')?.value && this.redeemCreditVoucherForm.get('creditVoucherRef')?.valid) {
      if (this.redeemCreditVoucherForm.get('TKTorEMDnumber')?.value) {
        ticket = {
          type: 'ETKT',
          number: this.redeemCreditVoucherForm.get('creditVoucherRefPrefix')?.value + this.redeemCreditVoucherForm.get('creditVoucherRef')?.value
        };
        if (!this.ticketNumbers.find((ticketNum: any) => ticketNum.number == ticket.number)) {
          this.ticketNumbers.push(ticket);
          this.ticketAndEMDList.push(ticket);
        } else {
          this.showDuplicateVoucherError = true;
        }
      } else {
        ticket = {
          type: 'EMD',
          number: this.redeemCreditVoucherForm.get('creditVoucherRefPrefix')?.value + this.redeemCreditVoucherForm.get('creditVoucherRef')?.value
        };
        if (!this.EMDList.find((ticketNum: any) => ticketNum.number == ticket.number)) {
          this.EMDList.push(ticket);
          this.ticketAndEMDList.push(ticket);
        } else {
          this.showDuplicateVoucherError = true;
        }
      }
      this.redeemCreditVoucherForm.get('creditVoucherRef')?.reset();
      this.ticketsAdded = false;
    }
  }
  setSwitchValue(formControl: any, event: any) {
    formControl.setValue(event.target.innerHTML);
  }
  showAdcCollectedCreditCard() {
    this.showAdcCollectedCreditCardCheckbox = true;
  }
  deltkt(ticket: string) {
    this.ticketNumbers = this.ticketNumbers.filter((object: any) => {
      return object.number !== ticket;
    });
    this.ticketAndEMDList = this.ticketAndEMDList.filter((object: any) => {
      return object.number !== ticket;
    });
    this.EMDList = this.EMDList.filter((object: any) => {
      return object.number !== ticket;
    });
  }
  getChangedValue1(event: any) {
    // console.log('event1 : ' + event);
  }
  onSelectUSCanadaFlightsOption(event: any) {
    // console.log(this.redeemCreditVoucherForm.get('confirmAdditionalCollection')?.value);
  }
  // Only Integer Numbers
  keyPressNumbers(event: any) {
    var charCode = event.which ? event.which : event.keyCode;
    // Only Numbers 0-9
    if (charCode < 48 || charCode > 57) {
      event.preventDefault();
      return false;
    } else {
      return true;
    }
  }

  clearErrorMsg() {
    this.showDuplicateVoucherError = false;
  }
  onUSCanadaFlightSelect(event: any) {
    if (event === true) {
      this.showSFPD = true;
    } else {
      this.showSFPD = false;
    }
  }
  onApplyNameChange(event: any) {
    if (event === true) {
      this.redeemCreditVoucherForm.get('nwBaci')?.setValidators([Validators.required]);
      this.redeemCreditVoucherForm.get('nwBaci')?.updateValueAndValidity();
    } else {
      this.redeemCreditVoucherForm.get('nwBaci')?.clearValidators();
      this.redeemCreditVoucherForm.get('nwBaci')?.updateValueAndValidity();
    }
  }
  onChangeCountry(selection: any) {
    let item1: any = {};
    //this.selectedCountry=selection.target.value;
    if (typeof selection === 'string') {
      item1 = this.countryList.find((i) => i.name === selection) || selection;
    } else {
      item1 = this.countryList.find((i) => i.name === selection.target.value) || selection.target.value;
    }

    this.selectedCountry = item1;
    this.requiredFieldError = false;
  }
  checkCheckBoxValidation() {
    this.submitted = false;
    if (!this.redeemCreditVoucherForm.value.confirmEMD) {
      this.isconfirmEMDChecked = false;
    }
    if (!this.redeemCreditVoucherForm.value.confirmAdditionalCollection) {
      this.isConfirmAdditionalCollectionChecked = false;
    }
  }
  ngAfterViewInit() {
    this.countryCode.nativeElement.value = { name: '(please select a country)', code: '0' };
  }
  keyPressSpace(event: any) {
    var charCode = event.which ? event.which : event.keyCode;

    if (charCode === 32) {
      event.preventDefault();
      return false;
    } else {
      return true;
    }
  }
}

function ev(ev: any, arg1: (Event: any) => void) {
  throw new Error('Function not implemented.');
}
